export class AppConfig {
  public API_BASE_URL: string;
  public BASE_HREF: string;

  // Additional Properties
  [key: string]: any;
  public VERISK_WIDJET_JS_URL : string;
  public VERISK_WIDJET_CSS_URL : string;
}